<template>
  <div class="page-container">
    <div class="content-wrap">
      <TopNavBar v-bind:secondTierLoadingDone="true"/>

      <b-container class="ga-text-page-container">
        <b-row>
          <b-col class="d-none d-md-block col-md-1 col-lg-2"></b-col>
          <b-col class="col-12 col-md-10 col-lg-8">
            <article class="ga-tool-page ga-entry-form">
              <header class="ga-entry-form__header">
                <h1 class="ga-tool-page__title">{{ $t('Term Add') }}</h1>
                <div class="ga-entry-form__header-actions">
                  <button
                    type="button"
                    class="ga-entry-form__icon-btn"
                    :class="{ 'ga-entry-form__icon-btn--active': showHelp }"
                    :title="$t('Manual')"
                    @click="toggleHelp"
                  >
                    <i class="fas fa-info-circle" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    class="ga-entry-form__icon-btn"
                    :class="{ 'ga-entry-form__icon-btn--active': showSettings }"
                    :title="$t('Select type')"
                    @click="toggleOptions"
                  >
                    <i class="fas fa-sliders-h" aria-hidden="true"></i>
                  </button>
                </div>
              </header>

              <div v-if="showHelp" class="ga-entry-help">
                <ul>
                  <li v-for="(item, idx) in helpItems" :key="'help-' + idx">{{ item }}</li>
                </ul>
              </div>

              <b-form @submit.prevent="submit">
                <section v-if="showSettings" class="ga-entry-form__section">
                  <div class="ga-form__label">{{ $t('Select type') }}</div>
                  <div class="ga-entry-form__type-row">
                    <label class="ga-entry-form__type">
                      <input v-model="type" :value="typeOptions[0]" type="radio" name="entry-type">
                      <span>{{ $t('Genderneutral') }}</span>
                    </label>
                    <label class="ga-entry-form__type">
                      <input v-model="type" :value="typeOptions[1]" type="radio" name="entry-type">
                      <span>{{ $t('Genderstar') }}</span>
                    </label>
                    <label class="ga-entry-form__type">
                      <input v-model="type" :value="typeOptions[2]" type="radio" name="entry-type">
                      <span>{{ $t('Pairform') }}</span>
                    </label>
                  </div>
                </section>

                <div class="ga-entry-form__tabs">
                  <button
                    type="button"
                    :class="['ga-entry-form__tab', !tabSwitch ? 'ga-entry-form__tab--active' : '']"
                    @click="changeTab(0)"
                  >{{ $t('Persons') }}</button>
                  <button
                    type="button"
                    :class="['ga-entry-form__tab', tabSwitch ? 'ga-entry-form__tab--active' : '']"
                    @click="changeTab(1)"
                  >{{ $t('Special case') }}</button>
                </div>

                <section class="ga-entry-form__fields">
                  <div v-if="!tabSwitch">
                    <label class="ga-form__label" for="singular_masculine">{{ $t('Singular masculine') }}</label>
                    <input
                      id="singular_masculine"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t('Enter singular masculine')"
                      v-model="singular_masculine"
                    >

                    <label class="ga-form__label" for="singular_feminine">{{ $t('singular feminine') }}</label>
                    <input
                      id="singular_feminine"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t('Enter singular feminine')"
                      v-model="singular_feminine"
                    >

                    <label class="ga-form__label" for="plural_masculine">{{ $t('plural masculine') }}</label>
                    <input
                      id="plural_masculine"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t('Enter plural masculine')"
                      v-model="plural_masculine"
                    >

                    <label class="ga-form__label" for="plural_feminine">{{ $t('plural feminine') }}</label>
                    <input
                      id="plural_feminine"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t('Enter plural feminine')"
                      v-model="plural_feminine"
                    >

                    <label class="ga-form__label" for="singular_gender_neutral">{{ $t('singular gender neutral') }}</label>
                    <input
                      id="singular_gender_neutral"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t(singularPlaceholder())"
                      v-model="singular_gender_neutral"
                    >

                    <label class="ga-form__label" for="plural_gender_neutral">{{ $t('plural gender neutral') }}</label>
                    <input
                      id="plural_gender_neutral"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t(pluralPlaceholder())"
                      v-model="plural_gender_neutral"
                    >
                  </div>

                  <div v-else>
                    <label class="ga-form__label" for="term">{{ $t('term') }}</label>
                    <input
                      id="term"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t('Enter term')"
                      v-model="term"
                    >

                    <div v-if="$v.$error">
                      <small class="ga-form__error-inline" v-if="!$v.alternative.specialCaseIsValidated">
                        {{ $t('if you enter term, please also provide alternative.') }}
                      </small>
                    </div>

                    <label class="ga-form__label" for="alternative">{{ $t('alternative') }}</label>
                    <input
                      id="alternative"
                      type="text"
                      class="ga-form__input ga-entry-form__input"
                      :placeholder="$t(alternativePlaceholder())"
                      v-model="alternative"
                    >
                  </div>

                  <label class="ga-form__label" for="example">{{ $t('example') }}</label>
                  <textarea
                    id="example"
                    class="ga-form__input ga-entry-form__input ga-entry-form__textarea"
                    rows="3"
                    :placeholder="$t('Enter example')"
                    v-model="example"
                  ></textarea>
                </section>

                <div v-if="error" class="ga-form__error">{{ error }}</div>
                <div v-if="success" class="ga-form__success">{{ success }}</div>

                <vue-recaptcha
                  v-if="showRecaptchaWidget"
                  @expired="onCaptchaExpired"
                  @verify="onCaptchaVerified"
                  ref="recaptcha"
                  :sitekey="this.recaptchaSiteKey"
                  size="invisible"
                ></vue-recaptcha>

                <div class="ga-entry-form__actions">
                  <button type="submit" class="ga-form__btn ga-form__btn--primary">{{ $t('Add') }}</button>
                </div>
              </b-form>
            </article>
          </b-col>
        </b-row>
      </b-container>

      <LoginWallModal ref="registerModal" />
      <div>
        <b-modal hide-footer ref="tabToggleModal" :title="$t('Persons/ special case')">
          <div class="d-block text-center">
            <h3>{{ $t('Do you want to change the type of this entry?') }}</h3>
            <small>{{ $t('Only data in the active tab will be saved') }}</small>
          </div>
          <b-button @click="activeTab" block class="mt-2 btn btn-outline-info btn-block">{{ $t('Yes') }}</b-button>
          <b-button @click="hideTabToggleModal" block class="mt-2 btn btn-outline-danger btn-block">{{ $t('Cancel') }}</b-button>
        </b-modal>
      </div>

      <GenderAppFooter/>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import TopNavBar from '../../../components/TopNavBar'
import { DictionaryEntryService } from '../../../services/dictionaryEntryService'
import { dictionaryEntryMixin } from '../../../mixins/dictionaryEntryMixin'
import { listMixin } from '../../../mixins/listMixin'
import GenderAppFooter from '../../../components/Footer'
import LoginWallModal from '../../../components/LoginWallModal'
import VueRecaptcha from 'vue-recaptcha'
import { recaptchaLoadMixin } from '../../../mixins/recaptchaLoadMixin'
import { needsRecaptchaScript } from '../../../utils/loadRecaptcha'
import { API_URL, RECAPTCHA_SITE_KEY } from '../../../env'
import axios from 'axios'

const specialCaseIsValidated = (alternative, vm) => {
  if (alternative) {
    if (vm.term === '') {
      vm.error = vm.$t('if you enter term, please also provide alternative')
      return false
    } else {
      return true
    }
  }
  return true
}
const singularIsValidated = (singularGenderNeutral, vm) => {
  if (singularGenderNeutral) {
    if (vm.singular_masculine === '' && vm.singular_masculine === '') {
      vm.error = vm.$t('if you enter singular gender neutral, you have to provide singular feminine and/or singular masculine.')
      return false
    } else {
      return true
    }
  }
  return true
}

const pluralIsValidated = (pluralGenderNeutral, vm) => {
  if (pluralGenderNeutral) {
    if (vm.plural_masculine === '' && vm.plural_feminine === '') {
      vm.error = vm.$t('if you enter plural gender neutral, you have to provide plural feminine and/or plural masculine.')
      return false
    } else {
      return true
    }
  }
  return true
}
const dictionaryEntryIsValid = (example, vm) => {
  const allIsEmpty = vm.singular_masculine === '' && vm.singular_feminine === '' && vm.plural_masculine === '' && vm.plural_feminine === '' && vm.term === ''
  if (allIsEmpty) {
    vm.error = vm.$t('please enter some gender specific terms')
    return false
  }
  return true
}

export default {
  name: 'DictionaryEntryAdd',
  metaInfo () {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: this.description
        },
        {
          property: 'og:title',
          vmid: 'og:title',
          content: this.title
        },
        {
          property: 'og:description',
          vmid: 'og:description',
          content: this.description
        },
        {
          property: 'og:url',
          vmid: 'og:url',
          content: this.canonicalUrl
        },
        {
          name: 'twitter:title',
          vmid: 'twitter:title',
          content: this.title
        },
        {
          name: 'twitter:description',
          vmid: 'twitter:description',
          content: this.description
        }
      ],
      link: [
        { rel: 'canonical', href: this.canonicalUrl }
      ]
    }
  },
  data () {
    return {
      showHelp: false,
      term: '',
      type: '',
      typeOptions: ['neut', 'star', 'pair'],
      alternativePlaceholders: ['Enter alternative neutral', 'Enter alternative star', 'Enter alternative pair'],
      singularPlaceholders: ['Enter singular neutral', 'Enter singular star', 'Enter singular pair'],
      pluralPlaceholders: ['Enter plural neutral', 'Enter plural star', 'Enter plural pair'],
      alternative: '',
      example: '',
      singular_masculine: '',
      singular_feminine: '',
      plural_masculine: '',
      plural_feminine: '',
      singular_gender_neutral: '',
      plural_gender_neutral: '',
      showSettings: false,
      tabSwitch: false,
      activateTabName: '',
      error: '',
      success: '',
      recaptchaSiteKey: RECAPTCHA_SITE_KEY,
      title: 'Neuer Eintrag · gender app',
      description: 'Erfasse einen neuen Eintrag und erweitere das demokratische Wörterbuch',
      canonicalUrl: 'https://genderapp.org/dictionary_entry/add'
    }
  },
  computed: {
    helpItems () {
      return [
        this.$t('add.help.1'),
        this.$t('add.help.2'),
        this.$t('add.help.3'),
        this.$t('add.help.4'),
        this.$t('add.help.5'),
        this.$t('add.help.6')
      ]
    }
  },
  mixins: [validationMixin, dictionaryEntryMixin, listMixin, recaptchaLoadMixin],
  validations: {
    alternative: {
      specialCaseIsValidated: specialCaseIsValidated
    },
    singular_gender_neutral: {
      singularIsValidated: singularIsValidated
    },
    plural_gender_neutral: {
      pluralIsValidated: pluralIsValidated
    },
    example: {
      dictionaryEntryIsValid: dictionaryEntryIsValid
    }
  },
  methods: {
    toggleHelp () {
      this.showHelp = !this.showHelp
    },
    onCaptchaExpired: function () {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
    },
    submit: function () {
      if (!needsRecaptchaScript(RECAPTCHA_SITE_KEY)) {
        this.onCaptchaVerified('secretKey')
        return
      }
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.execute()
      }
    },
    onCaptchaVerified (recaptchaToken) {
      const token = recaptchaToken
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset()
      }
      const instance = this
      const activetab = this.activateTabName
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (!this.error) {
          this.error = this.$t('Something went wrong')
        }
        return
      }
      axios.post(`${API_URL}/api/dictionary_entry_list/`, {
        term: instance.term,
        type: instance.type,
        alternative: instance.alternative,
        example: instance.example,
        singular_masculine: instance.singular_masculine,
        singular_feminine: instance.singular_feminine,
        plural_masculine: instance.plural_masculine,
        plural_feminine: instance.plural_feminine,
        singular_gender_neutral: instance.singular_gender_neutral,
        plural_gender_neutral: instance.plural_gender_neutral,
        recaptchaToken: token,
        activateTabName: activetab
      })
        .then((response) => {
          instance.success = response.data.detail || instance.$t('Registration successful. You can now login.')
          instance.error = ''
          const genderSpecificFields = [instance.singular_masculine, instance.singular_feminine,
            instance.plural_masculine, instance.plural_feminine, instance.term]
          const genderSpecificFieldsClean = genderSpecificFields.filter(n => n)
          instance.setUrl(genderSpecificFieldsClean[0] + '&sec' || '')
        })
        .catch((error) => {
          instance.error = error.message.error
          instance.success = ''
        })
    },
    showRegisterModal () {
      this.$refs.registerModal.show()
    },
    hideRegisterModal () {
      this.$refs.registerModal.hide()
    },
    showToggleModal () {
      this.$refs.tabToggleModal.show()
    },
    hideTabToggleModal () {
      this.$refs.tabToggleModal.hide()
    },
    alternativePlaceholder () {
      if (this.type === 'neut') {
        return this.alternativePlaceholders[0]
      } else if (this.type === 'star') {
        return this.alternativePlaceholders[1]
      } else if (this.type === 'pair') {
        return this.alternativePlaceholders[2]
      }
    },
    singularPlaceholder () {
      if (this.type === 'neut') {
        return this.singularPlaceholders[0]
      } else if (this.type === 'star') {
        return this.singularPlaceholders[1]
      } else if (this.type === 'pair') {
        return this.singularPlaceholders[2]
      }
    },
    pluralPlaceholder () {
      if (this.type === 'neut') {
        return this.pluralPlaceholders[0]
      } else if (this.type === 'star') {
        return this.pluralPlaceholders[1]
      } else if (this.type === 'pair') {
        return this.pluralPlaceholders[2]
      }
    },
    changeTab (tIndex) {
      this.showToggleModal()
    },
    activeTab () {
      this.tabSwitch = !this.tabSwitch
      this.activateTabName = this.tabSwitch ? 'special_case' : 'persons'
      this.hideTabToggleModal()
    },
    applyQueryPrefill () {
      const q = this.$route.query
      const pick = (key, field) => {
        const value = q[key]
        if (value != null && String(value).trim() !== '') {
          this[field] = String(value)
        }
      }
      pick('term', 'term')
      pick('sm', 'singular_masculine')
      pick('sf', 'singular_feminine')
      pick('pm', 'plural_masculine')
      pick('pf', 'plural_feminine')
    },
    mergeEntryPrefill (dataSet) {
      const assignIfEmpty = (field, value) => {
        if (!this[field] && value) this[field] = value
      }
      assignIfEmpty('term', dataSet.term)
      assignIfEmpty('singular_masculine', dataSet.singular_masculine)
      assignIfEmpty('singular_feminine', dataSet.singular_feminine)
      assignIfEmpty('plural_masculine', dataSet.plural_masculine)
      assignIfEmpty('plural_feminine', dataSet.plural_feminine)
    },
    applyEntryPrefill (dataSet) {
      this.term = dataSet.term || ''
      this.singular_masculine = dataSet.singular_masculine || ''
      this.singular_feminine = dataSet.singular_feminine || ''
      this.plural_masculine = dataSet.plural_masculine || ''
      this.plural_feminine = dataSet.plural_feminine || ''
    },
    setPrefillTab () {
      const hasPersonForms = !!(
        this.singular_masculine || this.singular_feminine ||
        this.plural_masculine || this.plural_feminine
      )
      this.tabSwitch = !!(this.term && !hasPersonForms)
      this.activateTabName = this.tabSwitch ? 'special_case' : 'persons'
    },
    async getObjectData () {
      this.applyQueryPrefill()

      const uid = parseInt(this.$route.query.uid, 10)
      if (!uid) {
        this.setPrefillTab()
        return false
      }

      try {
        const response = await DictionaryEntryService.getDictionaryEntryById(uid)
        if (this.$route.query.from === 'helfen') {
          this.mergeEntryPrefill(response.data)
        } else {
          this.applyEntryPrefill(response.data)
        }
      } catch (err) {
        if (!this.singular_masculine && !this.singular_feminine &&
            !this.plural_masculine && !this.plural_feminine && !this.term) {
          this.error = err.message.detail
        }
      }

      this.setPrefillTab()
      return true
    }
  },
  watch: {
    '$route.query.uid' () {
      this.getObjectData()
    }
  },
  async mounted () {
    await this.getObjectData()
    this.type = this.type || this.typeOptions[0]
  },
  components: { GenderAppFooter, TopNavBar, VueRecaptcha, LoginWallModal }
}
</script>
